import { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../slices/languageSlice';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const language = useSelector((state) => state.language.language);
    const { userDetails } = useSelector((state) => state.user);

    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(language.toUpperCase());
    const dropdownRef = useRef(null);

    const items = [
        { code: "FR", label: "French", flag: "assets/images/flags/fr.svg" },
        { code: "EN", label: "English", flag: "assets/images/flags/uk.svg" },
    ];

    useEffect(() => {
        i18n.changeLanguage(language);
        setSelected(language.toUpperCase());
    }, [language, i18n]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLanguageChange = (code) => {
        const lang = code.toLowerCase();
        dispatch(setLanguage(lang));
        setSelected(code);
        setOpen(false);
    };

    const activeItem = items.find((i) => i.code === selected);

    const [isOpen, setIsOpen] = useState(false); // ✔ renamed state
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate(`/${language}/login`);
        window.location.reload();
    }


    return (
        <header id="header" className="header admin-header light-bg">
            <div className="w-full">
                <div className="flex items-center gap-4">
                    {/* Menu Button */}
                    <button
                        id="collapsed-nav"
                        className="toggle-menu flex-none size-10 flex justify-center items-center rounded-lg border light-border bg-white cursor-pointer"
                        onClick={() => document.body.classList.toggle("iscollapsed")}
                    >
                        <img src="../../assets/images/icons/menu.svg" alt="Menu" className="icon-img" />
                    </button>

                    {/* Search Box */}
                    <div className="flex items-center [&_img]:light-dark-icon relative xl:min-w-96">
                        <input
                            type="text"
                            placeholder={t('searchPlaceholder')}
                            className="form-control !py-2 !pr-10 !bg-transparent"
                        />
                        <button
                            type="button"
                            className="w-8 h-8 !p-0 flex-none !flex justify-center items-center rounded-lg hover:bg-gray-100 absolute right-1 cursor-pointer"
                        >
                            <img src="../../assets/images/icons/search.svg" alt="Search" className="icon-img" />
                        </button>
                    </div>

                    {/* Top Right Menu */}
                    <ul className="flex items-center gap-x-0 list-none m-0 ml-auto">
                        {/* Notifications Button */}
                        <li className="relative mr-4">
                            <button className="relative w-8 h-8 flex items-center justify-center border-0 bg-transparent [&_img]:light-dark-icon cursor-pointer">
                                <span className="absolute top-0 end-0 z-[1] w-4 h-4 text-xs font-medium text-white bg-red-500 rounded-full flex items-center justify-center">
                                    3
                                </span>
                                <img src="../../assets/images/icons/bell.svg" alt="Notifications" className="w-7" />
                            </button>
                        </li>

                        {/* Profile */}
                        <li className="relative" ref={menuRef}>
                            <button
                                onClick={() => setIsOpen(!isOpen)}
                                className="dropdown-toggle flex items-center gap-2 px-2 py-2 rounded-lg hover:text-primary-500 transition cursor-pointer"
                            >
                                <div className="size-8 rounded-full overflow-hidden">
                                    <img src="../../assets/images/manager/man4.jpg" className="size-full object-cover" />
                                </div>

                                <div className="flex flex-col text-left">
                                    <h3 className="font-semibold">{userDetails.fullName}</h3>
                                </div>

                                <img
                                    src="../../assets/images/icons/arrow-chevron-downward.svg"
                                    className={`transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"
                                        }`}
                                    alt="Down arrow"
                                />
                            </button>

                            <ul
                                className={`absolute right-0 w-40 bg-white border rounded-lg mt-2 shadow-lg transition-all duration-300 origin-top ${isOpen
                                        ? "opacity-100 scale-100 visible"
                                        : "opacity-0 scale-95 invisible"
                                    }`}
                            >
                                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <button className="flex items-center gap-2">
                                        <img src="../../assets/images/icons/user.svg" alt="" />{t("profile")}
                                    </button>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <button className="flex items-center gap-2">
                                        <img src="../../assets/images/icons/gear.svg" alt="" />{t("settings")}
                                    </button>
                                </li>
                                <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                                    <button className="flex items-center gap-2" onClick={handleLogout}>
                                        <img src="../../assets/images/icons/exit.svg" alt="" />{t("logout")}
                                    </button>
                                </li>
                            </ul>
                        </li>
                        {/* <li>
                            <div className="dropdown">
                                <button
                                    className="dropdown-toggle cursor-pointer btn btn-primary !flex gap-1 !pl-3 !pr-5"
                                    type="button"
                                >
                                    <div className="overflow-hidden w-6">
                                        <img src={require("../../assets/images/icons/user.svg")} alt="" className="w-full h-full object-cover" />
                                    </div>
                                    <div className="text-left flex flex-col">
                                        <h3 className="font-semibold">{t('login')}</h3>
                                    </div>
                                </button>
                            </div>
                        </li> */}

                        {/* <li>
                            <span className="font-secondary font-semibold uppercase">{t('ticket')}</span>
                        </li> */}

                        <li>
                            <div className="relative inline-block" ref={dropdownRef}>
                                <button className="flex items-center gap-2 px-2 py-2 rounded-lg hover:text-primary-500 transition cursor-pointer" onClick={() => setOpen(!open)}>
                                    <div className="size-6 rounded-full overflow-hidden">
                                        <img
                                            src={activeItem.flag}
                                            alt={activeItem.code}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                    <span className="font-medium">{activeItem.code}</span>
                                    <img src="../../assets/images/icons/arrow-chevron-downward.svg" alt="arrow" className={`transition-transform duration-300 ${open ? "rotate-180" : "rotate-0"}`} />
                                </button>

                                {/* Dropdown menu */}
                                <div className={`absolute right-0 mt-2 w-36 bg-white shadow-lg rounded-lg overflow-hidden border transition-all duration-300 origin-top ${open
                                        ? "opacity-100 scale-100 visible"
                                        : "opacity-0 scale-95 invisible"
                                    }`}
                                >
                                    <ul>
                                        {items.map((item) => (
                                            <li
                                                key={item.code}
                                                onClick={() => handleLanguageChange(item.code)}
                                                className={`px-4 py-2 cursor-pointer flex items-center gap-2 hover:bg-gray-100 transition ${selected === item.code ? "bg-gray-200 font-semibold" : ""
                                                    }`}
                                            >
                                                <img src={item.flag} alt={item.code} className="size-5" />
                                                {item.label}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    )
}

export default Header